import 'simplebar/src/simplebar.css';
import axios from 'axios';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ConstantsProvider } from './context/constants_context';
import { ClientProvider } from './context/client_context';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { ProductProvider } from './context/product_context';
import { SettingProvider } from './context/setting_context';
import { EmployerProvider } from './context/employer_context';
import { AuthProvider } from './context/auth_context';
import { ClaimsProvider } from './context/claims_context';
import { InvoiceProvider } from './context/invoice_context';
import { AccountingProvider } from './context/accounting_context';
import { DocumentsProvider } from './context/document_context';

// axios.defaults.headers.common.Authorization = `Mombez ${sessionStorage.getItem('token')}`;

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <ConstantsProvider>
          <SettingProvider>
            <EmployerProvider>
              <ClientProvider>
                <DocumentsProvider>
                  <ProductProvider>
                    <ClaimsProvider>
                      <InvoiceProvider>
                        <AccountingProvider>
                          <App />
                        </AccountingProvider>
                      </InvoiceProvider>
                    </ClaimsProvider>
                  </ProductProvider>
                </DocumentsProvider>
              </ClientProvider>
            </EmployerProvider>
          </SettingProvider>
        </ConstantsProvider>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById('root')
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
